import DataTableEmptyState from './DataTableEmptyState';
import DataTableRow from './DataTableRow';
import type { ColumnDef, Table as ITable, Row } from '@tanstack/react-table';
import type { VirtualItem } from '@tanstack/react-virtual';

import { TableBody } from '../../Table';

interface DataTableBodyProps<TData, TValue> {
  selectedActions?: (table: ITable<TData>, columnsDef: any) => React.ReactNode;
  isVirtualized: boolean;
  rows: Row<TData>[];
  virtualizer: any;
  isLoading: boolean;
  columnPinning: any;
  columnsDef: ColumnDef<TData, TValue>[];
  data: TData[];
  table: ITable<TData>;
  emptyStatePlaceholder?: React.ReactNode;
}

const DataTableBody = <TData, TValue>({
  columnPinning,
  selectedActions: SelectedActions,
  isVirtualized,
  rows,
  virtualizer,
  isLoading,
  columnsDef,
  data,
  table,
  emptyStatePlaceholder,
}: DataTableBodyProps<TData, TValue>) => {
  return (
    <TableBody>
      {/* // SELECTED ACTIONS COMPONENTS  */}
      {SelectedActions && data ? SelectedActions(table, columnsDef) : null}

      {/* //  VIRTUALIZED */}
      {isVirtualized
        ? virtualizer
            .getVirtualItems()
            .map((virtualRow: VirtualItem, index: number) => {
              const row = rows[virtualRow.index];
              const selected = row.getIsSelected();
              return (
                <DataTableRow
                  key={virtualRow.key as number}
                  index={index}
                  columnPinning={columnPinning}
                  row={row as Row<unknown>}
                  virtualRow={virtualRow}
                  selected={selected}
                />
              );
            })
        : null}

      {/* // NOT VIRTUALIZED */}
      {!isVirtualized
        ? rows.map((row, index) => {
            const selected = row.getIsSelected();
            return (
              <DataTableRow
                key={row.id}
                index={index}
                row={row as Row<unknown>}
                columnPinning={columnPinning}
                selected={selected}
              />
            );
          })
        : null}

      <DataTableEmptyState
        rows={rows}
        isLoading={isLoading}
        columnsDef={columnsDef}
        placeholder={emptyStatePlaceholder}
      />
    </TableBody>
  );
};

export default DataTableBody;
